module.exports = __webpack_public_path__ + "img/dental-radix.52f8eb2e.svg";